<template lang="pug">
div
  UiCardSection
    UiCard(
      shadow="never"
      border="always"
    )
      UiCardSection
        UiStack
          UiStackItem(grow)
            h4 {{ $t("companies.reports.title") }}
          UiStackItem
            UiButton(
              @click="addReport()"
              icon="FilePlus"
            ) {{ $t("companies.reports.create_title") }}
        RestTable(
          ref="reportsTable"
          namespace="reports"
          :headers="headers"
          :fetchHandler="getData"
          embed
        )
          template(#cell:status="{ item }")
            ReportStatuses(
              :item="item"
              @show="showReport(item)"
            )
          template(#cell:name="{ item }")
            TaskName(:item="item")
          template(#cell:actions="{ item }")
            UiStack(spacing="xs")
              UiButton(
                size="sm"
                variant="smooth-danger"
                @click="deleteReport(item)"
                v-if="item.status != 'started'"
                icon="Trash"
              ) {{ $t("actions.delete") }}
              UiButton(
                size="sm"
                variant="smooth-warning"
                @click="restartJob(item)"
                v-if="item.status == 'error'"
                icon="RefreshCw"
              ) {{ $t("companies.reports.restart") }}
              UiButton(
                size="sm"
                variant="smooth-warning"
                @click="editReport(item)"
                v-if="(item.status == 'error') & ['twin_treasury_file', 'netvisor_opus_voucher', 'netvisor_importer_payment'].includes(item.report_type)"
                icon="PencilCreate"
              ) {{ $t("actions.edit") }}
  ScheduledTasks(ref="ScheduledTasks")
  CreateReportModal(
    ref="createReportModal"
    @done="reloadList"
    :iban="company.iban"
  )
  ShowReportModal(ref="showReportModal")
</template>

<script>
import ApiCompanyReports from "@/api/companyReports.js";
import ApiCompanies from "@/api/companies.js";
import CreateReportModal from "@/modals/Companies/createReport.vue";
import ShowReportModal from "@/modals/Companies/showReport.vue";
import ScheduledTasks from "@/views/Tasks/scheduledTasks.vue";
import TaskName from "@/views/Tasks/taskName.vue";
import ReportStatuses from "./reports/ReportStatuses.vue";

export default {
  components: {
    CreateReportModal,
    ShowReportModal,
    ScheduledTasks,
    TaskName,
    ReportStatuses,
  },

  data() {
    return {
      company: {},
      headers: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "report_type_name",
          label: "Type",
          sortable: true,
        },
        {
          key: "software_name",
          label: "Software",
        },
        {
          key: "name",
          label: "Report Files",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Created at",
          sortable: true,
        },
        {
          key: "end_at",
          label: "End at",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$refs.reportsTable.fetchData();
      this.$refs.ScheduledTasks.reloadList();
    },

    getData(params, config) {
      return ApiCompanyReports.fetchReports(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reports,
          meta: resp.data.meta,
        };
      });
    },

    showReport(item) {
      this.$refs.showReportModal.open(item);
    },

    addReport() {
      this.$refs.createReportModal.open(this.$route.params.id, null);
    },

    editReport(item) {
      this.$refs.createReportModal.open(this.$route.params.id, item);
    },

    deleteReport(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "briefcase-remove",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyReports.deleteReport(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },
    canDownload(item) {
      return item.file_exists;
    },

    itemName(item) {
      let itemName = "";
      const PROCESSING = this.$t("companies.reports.files_states.processing");
      const FILES_IMPORTED = this.$t("companies.reports.files_states.imported");
      const RESULT_UPLOADED = this.$t(
        "companies.reports.files_states.uploaded_to_sftp",
      );
      const TASK_WITHOUT_FILE = this.$t(
        "companies.reports.files_states.no_file",
      );

      switch (true) {
        case item.status !== "ok":
          itemName = PROCESSING;
          break;
        case item.import !== null:
          itemName = FILES_IMPORTED;
          break;
        case item.sftp_result:
          itemName = RESULT_UPLOADED;
          break;
        case item.file_exists:
          itemName = item.name;
          break;
        default:
          itemName = TASK_WITHOUT_FILE;
          break;
      }

      return itemName;
    },

    downloadReport(item) {
      ApiCompanyReports.downloadReport(this.$route.params.id, item.id)
        .then((resp) => {
          let filename = resp.headers["content-disposition"]
            .split(";")
            .find((n) => n.includes("filename="))
            .replace("filename=", "")
            .trim();
          let fileURL = window.URL.createObjectURL(
            new Blob([resp.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
          );
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", filename);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
    fetchData() {
      ApiCompanies.getCompany(this.$route.params.id).then((resp) => {
        this.company = resp.data.company;
      });
    },
    restartJob(item) {
      ApiCompanyReports.restartReport(this.$route.params.id, item.id).then(
        (resp) => {
          this.reloadList();
        },
      );
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
